import { render, staticRenderFns } from "./SearchTitle.vue?vue&type=template&id=2f6fb928&"
import script from "./SearchTitle.vue?vue&type=script&lang=js&"
export * from "./SearchTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f6fb928')) {
      api.createRecord('2f6fb928', component.options)
    } else {
      api.reload('2f6fb928', component.options)
    }
    module.hot.accept("./SearchTitle.vue?vue&type=template&id=2f6fb928&", function () {
      api.rerender('2f6fb928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/bottom/components/SearchTitle.vue"
export default component.exports